import theme from "../data/mapTheme.js";

import mitt from 'mitt'
import FindDistributors from '../vue/FindDistributors.vue'
import { createApp } from 'vue'

const ID = '#find-distributor-map'
const el = document.querySelector(ID)

function init() {

    if (!el) return;

    // Vue.prototype.$ThemeDir = el.dataset.theme

    window.addEventListener('mapsReady', () => {

        const app = createApp(FindDistributors)
        app.config.globalProperties.$bus = mitt() 
        app.config.globalProperties.data = JSON.parse(el.dataset.distributors)
        app.config.globalProperties.$google = window.google
        app.config.globalProperties.helpers = {
            stringToCoord: (string) => {
                if (!string) {
                    return {}
                }

                const coord = string.split(',')

                return {
                    lat: parseFloat(coord[0]),
                    lng: parseFloat(coord[1]),
                }
            }
        }
        app.mount(ID)
    })
}

init();

// const wrapper = document.querySelector(".distributor-map-wrapper");
// 
// function hideAllInfoWindows(markers) {
//     markers.forEach((marker) => {
//         marker.info.close();
//     });
// }
// 
// function openMarker(markers, marker) {
//     hideAllInfoWindows(markers);
// 
//     marker.info.open(marker.map, marker);
// }
// 
// function makeMarker(map, data) {
//     const { title, address, suburb, city, postcode, website, phone } = data;
// 
//     const content = `<div class="custom-popup">
//         <div class="custom-popup-content">
//             <p class="custom-popup__title">${title}</p>
//             <p class="custom-popup__address">
//                 ${address},<br />
//                 ${suburb},<br />
//                 ${city}
//             </p>
//             <div class="custom-popup__links">
//                 <span>
//                     <a href="${website}" target="_blank">${website}</a>
//                 </span>
//                 <span>
//                     <a href="tel:${phone}">${phone}</a>
//                 </span>
//             </div>
//             <div class="custom-popup__buttons">
//                 <a href="https://www.google.com/maps/place/${address}" target="blank" class="btn-bg-primary">View map</a>
//             </div>
//         </div>
//     </div>`;
// 
//     const icon = {
//         url: "/_resources/themes/livi/build/images/icons/MapPin.svg",
//         scaledSize: new google.maps.Size(50, 50), // scaled size
//     };
// 
//     const marker = new google.maps.Marker({
//         map: map,
//         position: data.latlng,
//         title: data.title,
//         id: data.id,
//         icon,
//         info: new google.maps.InfoWindow({
//             content,
//         }),
//     });
// 
//     return marker;
// }
// 
// function initMarkers(map) {
//     const distributors = JSON.parse(wrapper.dataset.distributors);
//     const markers = [];
// 
//     distributors.forEach((data) => {
// 
//         if(!data.latlng) {
//             return;
//         }
// 
//         data.latlng.lat = parseFloat(data.latlng.lat);
//         data.latlng.lng = parseFloat(data.latlng.lng);
// 
//         markers.push(makeMarker(map, data));
//     });
// 
//     map.addListener("click", () => {
//         hideAllInfoWindows(markers);
//     });
// 
//     markers.forEach((marker) => {
//         marker.addListener("click", () => {
//             openMarker(markers, marker);
//             map.panTo(marker.getPosition());
//         });
//     });
// 
//     return markers;
// }
// 
// function initChoices(map, markers) {
//     const select = document.querySelector(".distributor-map__picker select");
// 
//     const choices = new Choices(select, {
//         searchEnabled: false,
//         itemSelectText: "",
//     });
// 
//     choices.passedElement.element.addEventListener("choice", (e) => {
//         const id = parseInt(e.detail.choice.value);
// 
//         const marker = markers.find((marker) => {
//             return marker.id === id;
//         });
// 
//         hideAllInfoWindows(markers);
// 
//         marker.info.open(map, marker);
//         map.panTo(marker.getPosition());
//     });
// }
// 
// function initMap() {
//     let center = { lat: -37.8598108, lng: 169.4237971 };
// 
//     if (window.innerWidth < 1024) {
//         center = { lat: -40.8598108, lng: 174.4237971 };
//     }
// 
//     const map = new google.maps.Map(
//         document.querySelector(".distributor-map"),
//         {
//             center,
//             zoom: 6,
//             styles: theme,
//             disableDefaultUI: true,
//         }
//     );
// 
//     const markers = initMarkers(map);
// 
//     initChoices(map, markers);
// }
// 
// function injectScript() {
//     const key = document.getElementById("GOOGLE_MAPS_FRONTEND").value;
// 
//     if (!key) {
//         throw new Exception(
//             "The map will not work without an API KEY. Make sure you include it in your .env file."
//         );
//     }
// 
//     const script = document.createElement("script");
//     script.setAttribute("async", true);
//     script.setAttribute(
//         "src",
//         `https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap`
//     );
//     document.body.appendChild(script);
// }
// 
// function init() {
//     if (!wrapper) return;
// 
//     injectScript();
// }
// 
// window.initMap = initMap;
// 
// init();
